import { sendStakes } from "../settings/useSettings"

export default function useCustomMessages(sendSocketMessage: any) {
    const placeBet = (stakes: any, place: string, cashoutAt: string) => {
        const stake = place == '0' ? stakes.firstStake : stakes.secondStake
        sendSocketMessage('bet', stake, place.toString(), cashoutAt.toString())
    }
    const cashout = (index: number) => sendSocketMessage('cashout', index.toString())
    const jackpotStep = (index: number) => sendSocketMessage('jackpotstep', index)
    const getJackpot = () => sendSocketMessage('jackpot')
    const getFullPreviousRounds = () => sendSocketMessage('fullround')


    return { placeBet, cashout, getJackpot, jackpotStep, getFullPreviousRounds }
}
